import * as React from 'react';

const Microphone = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={40} height={40} fill="none" viewBox="0 0 24 24" {...props}>
        <g
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            clipPath="url(#microphone_a)"
        >
            <path d="M2.25 9.75v3M.75 11.25h3M5.25.75v3M3.75 2.25h3M6.75 9a3.75 3.75 0 1 0 7.5 0 3.75 3.75 0 0 0-7.5 0M7.848 11.652l5.304-5.304" />
            <path d="m14.213 9.531 4.772 4.769a2.32 2.32 0 0 1 .094 3.276 2.32 2.32 0 0 1-3.276-.094l-4.772-4.772M12.75 14.432v8.818M10.5 23.25H15M16.568 5.741 21.75.75l1.5 21.669M.881 22.074l5.135-6.173" />
            <path d="M22.449 23.25c.512-.257.8-.537.8-.831 0-1.243-5.037-2.25-11.25-2.25S.75 21.176.75 22.419c0 .293.286.574.8.831" />
        </g>
        <defs>
            <clipPath id="microphone_a">
                <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
        </defs>
    </svg>
);
export default Microphone;
